import React from "react";
import { Button } from "@fluentui/react-northstar";

const RequestAssistanceButton = (props) => (
  <Button
    data-testid="requestAssistanceButton"
    content="Request Assistance"
    primary
    onClick={props.onClick}
  />
);

export default RequestAssistanceButton;
